import { useEffect } from 'react'

import { UILoading } from 'components'
import { useNavigate } from 'react-router-dom'

export const RedirectNavigation = () => {
  const navigate = useNavigate()

  const urlParams = new URLSearchParams(window.location.search)

  useEffect(() => {
    if (urlParams.get('flow') === 'connections') {
      navigate(`/connections?authorization_id=${urlParams.get('authorization_id')}`)
    } else {
      navigate(`/intro?authorization_id=${urlParams.get('authorization_id')}`)
    }
  }, [])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
      }}
    >
      <UILoading width={30} height={30} />
    </div>
  )
}
